import { select, put } from "redux-saga/effects";
import { setAccessToken } from "../../api/api";
import { updatedAuth } from "../actions/actions-auth";
import { emitter } from "../../common/utils/emitter";

export function* requestUpdateAuth(action) {
  try {
    const state = yield select();
    const { auth } = state;

    // Check if auth data exist. If yes refresh the auth data.
    if (auth) {
      yield put(updatedAuth(auth));
      setAccessToken(auth.access_token);
      emitter.emit("LOADED", false);
    } else {
      // Otherwise, get the auth data from the action (new app installed).
      const { auth } = action;
      yield put(updatedAuth(auth));
      setAccessToken(auth.access_token);
    }

    // const profile = yield call(apiUser.getUserDetail, action.auth.user._id)
    // if (!profile.error) {
    //   yield put(saveUserData(profile))
    // }
  } catch (e) {}
}
